module.exports = __webpack_public_path__ + "media/images/icons/outlined/bug-2dbb4935d4d677ca8a5b9f4b507cf213.svg";